<template>
  <el-col class="chart-module" :lg="12" v-loading="loading">
    <div class="sub-view">
      <!-- 标题栏 -->
      <el-row>
        <!-- 图表标题 -->
        <span style="font-weight: bold">{{ displayTitle }}</span>
        <!-- 关闭Icon -->
        <i class="el-icon-close" v-if="$root.editMode" @click="$root.onClose(title)"></i>
        <!-- 放大Icon -->
        <i class="el-icon-zoom-in" v-else @click="showPopUp()"></i>
      </el-row>
      <!-- 时间选择栏 -->
      <el-row>
        <div style="float: right">
          {{ this.$root.htmlConst.cons_223_aggregate_period }}
          <!-- 跳转到Redmine时需要的日期格式是yyyy-MM-dd格式，图表展示时需要的是yyyy/MM/dd格式 -->
          <el-date-picker
            v-model="datePicker"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="〜"
            :picker-options="pickerOptions"
            @change="handlePeriodChange('main')"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            :clearable="false"
          >
          </el-date-picker>
        </div>
      </el-row>
      <!-- 分割线 -->
      <hr />
      <el-row>
        <echarts
          class="chart-view"
          :autoresize="true"
          :option="option"
          @click="onClick"
          @timelinechanged="handleTimelineChange"
        />
      </el-row>
      <!-- 放大之后的图表 -->
      <el-dialog
        :visible.sync="popUpDisplay"
        :append-to-body="true"
        class="historyDailog"
      >
        <template slot="title">
          <el-row>
            <span style="font-weight: bold; margin-right: 10px">
              {{displayTitle}}
            </span>
          </el-row>
          <el-row>
            <div style="float: right">
              {{ this.$root.htmlConst.cons_223_aggregate_period }}
              <!-- 跳转到Redmine时需要的日期格式是yyyy-MM-dd格式，图表展示时需要的是yyyy/MM/dd格式 -->
              <el-date-picker
                v-model="datePicker"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="〜"
                :picker-options="pickerOptions"
                @change="handlePeriodChange('popup')"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                :clearable="false"
              >
              </el-date-picker>
            </div>
          </el-row>
        </template>
        <hr />
        <echarts
          :autoresize="true"
          :option="option"
          style="height: 75vh"
          v-loading="popupLoading"
          @click="onClick"
          @timelinechanged="handleTimelineChange"
        />
      </el-dialog>
    </div>
  </el-col>
</template>

<script>
import api from "@/api";
import * as echarts from 'echarts';
import 'echarts-wordcloud';
export default {
  name: "BuzzWordMapChart",
  props: ["title", "displayTitle"],
  data() {
    return {
      // 期间选择器选项
      pickerOptions: {
        shortcuts: [
          {
            text: "Last Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 7);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 7);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 30);

              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // 当前选择的期间
      datePicker: [this.$root.startDate, this.$root.endDate],
      // 图表选项
      option: {
        tooltip: {
          trigger: "axis",
        },
        title: {
          right: "10%",
        },
        timeline: {
          axisType: "category",
          autoPlay: false,
          playInterval: 1000,
          data: ["ALL", "AI CHATBOT", "AI ASSISTANT"],
          label: {
            show: false,
            interval: 0,
            formatter: function (s) {
              return s;
            },
          },
          bottom: '1%',
          padding: [10, -100],
        },
        grid: {
          top: 80,
          bottom: 80,
        },
        series: [
          {
            type: "wordCloud",
            data: [],
            sizeRange: [6, 56],
            clickable: true,
            rotationRange: [-45, 90],
            shape: "pentagon",
            drawOutOfBound: false,
            textStyle: {
              color: function () {
                return (
                  "rgb(" +
                  [
                    Math.round(Math.random() * 160),
                    Math.round(Math.random() * 160),
                    Math.round(Math.random() * 160),
                  ].join(",") +
                  ")"
                );
              },
            },
            emphasis: {
              focus: 'self',
              textStyle: {
                  textShadowBlur: 10,
                  textShadowColor: '#333'
              }
            },
          },
        ],
      },
      // 图表加载状态
      loading: false,
      // 弹窗中的图表加载状态
      popupLoading: false,
      // 是否显示弹窗
      popUpDisplay: false,
      // 当前时间线在所有时间线中的下标
      currentTimeLineIndex: 0
    };
  },
  mounted() {
    // 检索条件的基准月变化时，更新当前图表的集计期间
    this.$bus.$on("changeEndMonth", (startDate, endDate) => {
      this.datePicker = [startDate, endDate];
      this.handlePeriodChange("main");
    });
    // 图表初始化
    this.init();
  },
  methods: {
    // 图表初始化
    init() {
      this.getBuzzWordCount('main');
    },
    // 打开大图模式
    showPopUp() {
      this.popUpDisplay = true;
    },
    // 点击跳转到Redmine
    onClick(element) {
      console.log('this.datePicker', this.datePicker)
      // 当前选择的时间线
      let currentTimeLine = this.option.timeline.data[this.currentTimeLineIndex];
      // 当前点击的高频词
      let buzzWord = element.name;
      // Timeline切换时不处理，只有点击系列中的词云条目时才跳转到Redmine
      if (element.componentType === 'series') {
        let ageAndSexStr = '';
        if (this.$root.ageForEchart != '') {
          ageAndSexStr += "&f%5B%5D=cf_89&op%5Bcf_89%5D=~&v%5Bcf_89%5D%5B%5D=" + this.$root.ageForEchart[0];
        }
        if (this.$root.sexForEchart != '') {
          ageAndSexStr += "&f%5B%5D=cf_90&op%5Bcf_90%5D=~&v%5Bcf_90%5D%5B%5D=" + this.$root.sexForEchart[0];
        }
        if (currentTimeLine === "ALL") {
          window.open(
            this.$root.redmineUrl +
              "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
              this.datePicker[0] +
              "&v%5Bcreated_on%5D%5B%5D=" +
              this.datePicker[1] +
              "&f%5B%5D=cf_22&op%5Bcf_22%5D=%7E&v%5Bcf_22%5D%5B%5D=" +
              buzzWord +
              "&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
              + ageAndSexStr
          );
        } else if (currentTimeLine == "AI CHATBOT") {
          window.open(
            this.$root.redmineUrl +
              "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=2&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
              this.datePicker[0] +
              "&v%5Bcreated_on%5D%5B%5D=" +
              this.datePicker[1] +
              "&f%5B%5D=cf_22&op%5Bcf_22%5D=%7E&v%5Bcf_22%5D%5B%5D=" +
              buzzWord +
              "&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
              + ageAndSexStr
          );
        } else if (currentTimeLine == "AI ASSISTANT") {
          window.open(
            this.$root.redmineUrl +
              "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
              this.datePicker[0] +
              "&v%5Bcreated_on%5D%5B%5D=" +
              this.datePicker[1] +
              "&f%5B%5D=cf_22&op%5Bcf_22%5D=%7E&v%5Bcf_22%5D%5B%5D=" +
              buzzWord +
              "&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
              + ageAndSexStr
          );
        }
      }
    },
    // 期间选择变化时重新加载数据
    handlePeriodChange(which) {
      this.getBuzzWordCount(which);
    },
    // 处理时间线变化
    handleTimelineChange(timeline) {
      this.currentTimeLineIndex = timeline.currentIndex;
    },
    // 获取高频词数量API
    getBuzzWordCount(which) {
      // 改变图表加载状态
      this.updateLoadingStatus(true, which);
      // 调用获取高频词数量API
      api.getBuzzWordCount(this.datePicker[0], this.datePicker[1], this.$root.facetForEchart, this.$root.ageForEchart, this.$root.sexForEchart).then(
        (res) => {
          if (res.data) {
            let data_list = [];
            res.data.output_list.forEach((ele, i) => data_list.push({
              title: {
                text: this.option.timeline.data[i],
              },
              series: {
                type: "wordCloud",
                data: ele,
              },
            }))
            this.option = {
              ...this.option,
              options: data_list,
            };
            this.updateLoadingStatus(false, which);
          } else {
            this.$message.error('SystemError');
            this.updateLoadingStatus(false, which);
          }
        },
        (err) => {
          this.$message.error('SystemError');
          this.updateLoadingStatus(false, which);
        }
      );
    },
    // 更新图表加载状态
    updateLoadingStatus(status, which) {
      if (which === 'main') {
        this.loading = status;
      } else if (which === 'popup') {
        this.popupLoading = status;
      }
    }
  }
};
</script>

<style>
html,
body,
#main {
  width: 100%;
  height: 100%;
  margin: 0;
}
</style>